import { createFingerprint } from './fingerprinting';

let localDeviceId = '';
/** 获取设备信息 */
export function getDeviceId() {
  let deviceId = ref('');

  const cookieOpt = {
    expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
  };
  if (import.meta.client) {
    if (localDeviceId) {
      return localDeviceId;
    }
    deviceId = useCookie('__CLIENT_INFO_DEVICE_ID__', cookieOpt);
    if (!deviceId.value) {
      localDeviceId = String(createFingerprint());
      deviceId.value = localDeviceId;
    } else {
      localDeviceId = deviceId.value;
    }
  } else {
    deviceId = useCookie('__CLIENT_INFO_DEVICE_ID__');
  }

  return deviceId.value;
}

export function getAppVersion(userAgent: string, { isWx = false, isHopegoo = false } = {}) {
  const route = useRoute();

  if (isWx) {
    let ver = route.query['_miniAppVersion'] as string;
    if (ver) {
      useCookie('___WX_MINI_APP_Version__').value = ver;
      return ver;
    }
    ver = useCookie('___WX_MINI_APP_Version__').value || '';
    return ver || '1.0.0';
  }

  if (isHopegoo) {
    const ua = userAgent?.toLocaleLowerCase();
    const match = ua.match(/app_version=([\d.]+)/);
    if (match) {
      return match[1];
    }
  }

  return '1.0.0';
}
